import styled from 'styled-components';
import { getSpacing, headerHeight, pageWidth, zIndex } from 'stylesheet';
export var DivContainer = styled.div.withConfig({
  displayName: "Editstyle__DivContainer",
  componentId: "sc-1usetyd-0"
})(["position:relative;"]);
export var FixedTopLeft = styled.div.withConfig({
  displayName: "Editstyle__FixedTopLeft",
  componentId: "sc-1usetyd-1"
})(["position:fixed;top:calc(", " + ", ");left:calc(50% - ", "px + ", ");z-index:", ";"], headerHeight, getSpacing(4.5), pageWidth.small / 2, getSpacing(3), zIndex.header);
export var Form = styled.form.withConfig({
  displayName: "Editstyle__Form",
  componentId: "sc-1usetyd-2"
})(["width:100%;max-width:920px;"]);